'use client';
import { Suspense } from 'react';
import LoginPage from '@/components/pages/login/LoginPage';

export default function SignIn() {
  return (
    <Suspense>
      <LoginPage />
    </Suspense>
  );
}